<a class="skip-main" href="#skipMenu">Skip to main content</a>
<div id="top"></div>
<div class="appHeader weaveWrapper" id="mainHeader">
  <div class="appHeader-logo">
    <a routerLink="/home" tabindex=0>
      <img ngSrc="/assets/img/logos/Weave-Horizontal-Logo-DarkText-RGB.svg" alt="Weave Accreditation Logo"
           width="120" height="28">
    </a>
  </div>
  <div class="appHeader-message">
    <app-header-account-info></app-header-account-info>
  </div>
  <div class="appHeader-right">
    <div class="appHeader-menu">
      @if (!isEvaluatorActingForAccreditor) {
        <app-burger-menu [canShowMenu]="canShowMenu"></app-burger-menu>
      }
    </div>
    @if (canShowMenu.canImpersonate) {
      <div class="appHeader-impersonate">
        <app-impersonate></app-impersonate>
      </div>
    }
    <div class="appHeader-help">
      <app-help></app-help>
    </div>
    <div class="appHeader-notifications">
      <app-notifications-responsive
        [currentUser]="currentUser"
      ></app-notifications-responsive>
    </div>
    <div class="appHeader-userMenu">
      <app-right-menu [canShowMenu]="canShowMenu" [currentUser]="currentUser"></app-right-menu>
    </div>
  </div>
</div>
@if (!online) {
  <div>
    <a (click)="showNoInternetModal()" class="ion-alert-circled"></a>
  </div>
}
<div id="skipMenu"></div>
